import { GetLabelListParams } from '@modusign/openapi-client-category/generated/model';

import { ResourceRoleSubject } from '../authorization';

export type LabelResourceRoleSubject =
  | ResourceRoleSubject
  | { subjectType: 'WORKSPACE'; subjectId: string };

export type LabelInputType = 'button' | 'checkbox';
export interface Label {
  id: string;
  workspaceId: string;
  name: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
}

export type LabelFilters = Omit<GetLabelListParams, 'offset' | 'limit' | 'resourceType'>;

export type Unlabeled = 'unlabeled';
export const UNLABELED_ID: Unlabeled = 'unlabeled';
/**
 * string 타입을 사용하면서, 특정한 값이 추론, 자동완성될 수 있게 한다. string 집합 중 특정한 경우(known case)를 강조할 수 있다.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
type HintedString<KnownString extends string> = (string & {}) | KnownString;

/**
 * labelId의 값으로서 'unlabeled'로 지정할 수 있는 경우, 라벨id 필터 자체를 invert방식으로 선택한다고 봅니다
 * @see https://developer.chrome.com/ko/blog/new-in-devtools-94/#invert-network-filter
 *
 * labelId의 타입 - string('unlabeled'이 필터 invert 선택를 위한 특별히 Hint로서 추론됨) | undefined
 */
export type InvestibleSelectableLabelId = HintedString<'unlabeled'> | undefined;
